import React from "react";
import { Breadcrumb, NeoDateRangePicker, NeoButton, NeoAlert } from "../../../components/Common";
import { useCancellations } from "./hooks/useCancellations";
import CancellationsTable from "./components/CancellationsTable";
import { useTenant } from "../../../hooks/useTenant";

/**
 * CancellationsPage
 * Tela de Cancelamentos — mesmo padrão de Receivables/Payables/Sales.
 */
const CancellationsPage = () => {
    document.title = "Cancelamentos | NeoApp - Sistema de Gestão";

    const { idTenant } = useTenant();
    const {
        records,
        loading,
        error,
        hasMore,
        search,
        startDate,
        endDate,
        setSearch,
        setStartDate,
        setEndDate,
        loadMore,
        refresh,
        applyDateFilters,
        hasFetched,
    } = useCancellations(idTenant);

    return (
        <React.Fragment>
            {/* TOP BAR: Cabeçalho & Filtro de Período */}
            <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-4 gap-3">
                <div>
                    <Breadcrumb title="Cancelamentos" breadcrumbItem="Gerencial" />
                    <p className="text-muted mb-0 font-size-13 mt-0.5">
                        Controle de cancelamentos, motivos e análise de churn do período.
                    </p>
                </div>

                <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 flex-shrink-0">
                    <NeoDateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        onChange={({ startDate: s, endDate: e }) => {
                            if (s !== undefined) setStartDate(s);
                            if (e !== undefined) setEndDate(e);
                        }}
                        placeholder="Selecione o período..."
                        size="sm"
                        className="mb-0 neo-daterangepicker-filter"
                    />
                    <NeoButton
                        variant="primary"
                        size="sm"
                        onClick={applyDateFilters}
                        loading={loading}
                        icon="mdi-magnify"
                        square
                        title="Buscar"
                        className="neo-filter-search-btn"
                    />
                </div>
            </div>

            <div className="border-top mb-4"></div>

            {/* ═══ ERRO ═══ */}
            {error && !loading && (
                <NeoAlert color="danger" className="mb-3">
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-circle-outline me-2 fs-5" />
                        <div>
                            <strong>Erro ao carregar dados:</strong> {error?.message || String(error)}
                            <button className="btn btn-link btn-sm p-0 ms-2 fw-bold text-danger" onClick={refresh}>
                                Tentar novamente
                            </button>
                        </div>
                    </div>
                </NeoAlert>
            )}

            {/* ═══ TABELA ═══ */}
            {!error && (
                <CancellationsTable
                    records={records}
                    search={search}
                    onSearchChange={setSearch}
                    onLoadMore={loadMore}
                    hasMore={hasMore}
                    loading={loading}
                    hasFetched={hasFetched}
                />
            )}
        </React.Fragment>
    );
};

export default CancellationsPage;
